import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: 710,
    },
    dialogContent: {
      padding: theme.spacing(5, 4),
    },
    label: {
      marginBottom: theme.spacing(1),
    },
    url: {
      width: '100%',
    },
    error: {
      margin: theme.spacing(1),

      '&&': {
        color: COLORS.error.active,
      },
    },
  }),
  { name: 'CreateTalkingPointsViewPopup' }
);
